import * as React from "react";
const SvgIconMenuNav = props => <svg xmlns="http://www.w3.org/2000/svg" width={4} height={33} fill="none" viewBox="0 0 4 33" {...props}><path fill="#9747FF" d="M0 33V0a4 4 0 0 1 4 4v25a4 4 0 0 1-4 4" /></svg>;
export default SvgIconMenuNav;